export default "__VITE_ASSET__CsuzJhDu__"